import { useApiRequestOptions } from '../../hooks';

export const useIssueCategoryListApi = () => useApiRequestOptions({
  uri: 'issue_categories',
}, []);
